module.exports = __webpack_public_path__ + "static/media/punks-not-dead.3104375c.mp3";